// import api from '@/common/api';
import { cloneDeep } from 'lodash';
import { sleep } from '@/common/util.js';

// import Vue from 'vue';
/* eslint-disable */

const emptyPosition = {
  role: 0, 
  level: 0, 
  tasks: '', 
  competenses: '',
  candidates: [],
  selected_candidate_id: 0,
}  

const emptyCandidate = { 
  id: 0, 
  name: 'Не найден', 
  skills: '', 
  match: 0, matchedSkills: '' 
}

const allCandidates = [
  {id: 1, name: 'Иванов Иван Иванович', skills: 'Agile', },
  {id: 2, name: 'Петров Петр Петрович', skills: 'Agile, User Stories', },
  {id: 3, name: 'Сидоров Сидор Сидорович', skills: 'Jira', },
  {id: 4, name: 'Александров Александр Александрович', skills: 'A/B-тестирование', },
  {id: 5, name: 'Кузнецов Кузьма Кузьмич', skills: 'риск-менеджмент, SMM', },
  {id: 6, name: 'Смирнов Смирно Смитович', skills: 'User Stories, A/B-тестирование', },
  {id: 7, name: 'Попов Попов Попович', skills: 'Jira, риск-менеджмент, User Stories', },
  {id: 8, name: 'Васильев Василий Васильевич', skills: 'A/B-тестирование, Agile', },
  {id: 9, name: 'Михайлов Михаил Михайлович', skills: 'Jira, Agile, риск-менеджмент', },
  {id: 10, name: 'Новиков Новик Новикович', skills: 'User Stories, A/B-тестирование', },
  {id: 11, name: 'Федоров Федор Федорович', skills: 'Jira, риск-менеджмент, Agile, Копирайтинг', }, 
  {id: 12, name: 'Соколов Соколь Соколович', skills: 'Аналитика, работа с данными', },
  {id: 13, name: 'Орлов Орлов Орлович', skills: 'Анализ потребностей, коммуникация с общественностью', },
  {id: 14, name: 'Козлов Козлов Козлович', skills: 'Копирайтинг, SMM', },
]


const emptyProject = 
{ 
  id: 0, 
  name: 'Новый проект', 
  description: 'Краткое описание проекта',
  date_from: '2025-01-01', 
  date_to: '2025-01-02', 
  status: 'planned', 
  ai_result: false, 
  vacancies: '0/0',
  positions: [
    {
      role: 0, 
      level: 0, 
      tasks: '', 
      competenses: ''
    }
  ]
}


const defProjects = [
  { id: 1, name: 'Разработка платформы для онлайн-обучения', description: 'Краткое описание проекта - Разработка платформы для онлайн-обучения', date_from: '2025-01-10', date_to: '2025-02-10', status: 'in_progress', ai_result: true, vacancies: '2/5',
    positions: [
      { role_id: 1, level_id:2, tasks: 'Архитектура приложения, код-ревью, решение сложных технических проблем.', competenses: 'Jira, риск-менеджмент, A/B-тестирование.'  },
      { role_id: 2, level_id:1, tasks: 'Разработка пользовательского интерфейса, взаимодействие с API, тестирование.', competenses: 'Agile, Jira, риск-менеджмент.' },
      { role_id: 3, level_id:3, tasks: 'Разработка серверной части, работа с базами данных, интеграция с внешними сервисами.', competenses: 'Agile, User Stories.' },
    ]
  },
  { id: 2, name: 'Программа поддержки старшего поколения', description: 'Краткое описание проекта - Программа поддержки старшего поколения', date_from: '2025-03-10', date_to: '2025-04-10', status: 'completed', vacancies: '5/5', 
    positions:[
      { role_id: 1, level_id: 2, tasks: 'Организация мероприятий, взаимодействие с общественными организациями, привлечение волонтеров.', competenses: 'Анализ потребностей, коммуникация с общественностью.' },
      { role_id: 2, level_id: 1, tasks: 'Разработка информационных материалов, работа с социальными сетями.', competenses: 'Копирайтинг, SMM.' },
      { role_id: 3, level_id: 3, tasks: 'Анализ эффективности программы, подготовка отчетности.', competenses: 'Аналитика, работа с данными.' }
    ] },
  { id: 3, name: 'Внедрение Agile в отделы продаж', description: '', date_from: '2025-03-10', date_to: '2025-04-10', status: 'planned', vacancies: '1/5', positions:[] },
]


function matchCandidatesByCompetences(competencesInput) {
  const targetCompetences = (typeof competencesInput === 'string'
    ? competencesInput.split(',')
    : competencesInput
  ).map(c => c.trim().toLowerCase()).filter(Boolean);

  return allCandidates
    .map(candidate => {
      const candidateSkills = candidate.skills
        ?.split(',')
        .map(skill => skill.trim().toLowerCase()) || [];

      const matchedSkills = candidateSkills.filter(skill =>
        targetCompetences.includes(skill)
      );

      const matchPercent = Math.round((matchedSkills.length / targetCompetences.length) * 100);

      if (matchedSkills.length > 0) {
        return {
          ...candidate,
          match: matchPercent,
          matchedSkills: matchedSkills.join(', '), // опционально — можно удалить
        };
      }

      return null;
    })
    .filter(Boolean)
    .sort((a, b) => b.match - a.match); // по убыванию
}



const initialState = () => ({
  items: [],
  roles: [{id: 1, name: 'Руководитель'}, {id: 2, name: 'Frontend-разработчик'},  {id: 3, name: 'Backend-разработчик'}],
  levels: [{id: 1, name: 'Senior'}, {id: 2, name: 'middle'},  {id: 3, name: 'Junior'}],
  loading: {
    load: false,
    loadProject: 0,
    delProject: false,
    saveProject: false,
    calcProject: false,
  },
  errors: {
    load: [],
    loadProject: [],
    delProject: [],
    saveProject: [],
    calcProject: [],
  },
  count: 0,
  selected: [],
  filter: {
    pageSize: 20,
    page: 1,
    name: '',
    date_from: null,
    date_to: null,
    status: '',
    comment: '',
  },
  curProject: {}
});


export default {
  namespaced: true,
  state: cloneDeep(initialState()),
  getters: {
    loading: (state) => state.loading,
    errors: (state) => state.errors,
    count: (state) => state.count,
    filter: (state) => state.filter,
    items: (state) => state.items,
    selected: (state) => state.selected,
    roles: (state) => state.roles,
    levels: (state) => state.levels,
    curProject: (state) => state.curProject,
    isFilterEmpty: (state) => !state.filter.name && !state.filter.type && !state.filter.source
      && !state.filter.from_date_joined && !state.filter.to_date_joined && !state.filter.comment,
    getRoleName: (state) => (id) => {
      const role = state.roles.find((r) => r.id === id);
      return role ? role.name : '';
    },
    getCandidatesByCompetences: (state) => (position) => {
      return matchCandidatesByCompetences(position.competences);
    },
    getSelectedCandidate: (state) => (positionIndex) => {
      if (state.curProject && state.curProject.positions && positionIndex >= 0 && positionIndex < state.curProject.positions.length) {
        const position = state.curProject.positions[positionIndex];
        if (position && position.selected_candidate_id) {
          const candidate = position.candidates.find(c => c.id === position.selected_candidate_id);
          return candidate ?? emptyCandidate;
        } 
      }
      return emptyCandidate;
    }
  },
  mutations: {
    startLoading(state, field) {
      state.loading[field] = true;
    },
    startLoadingId(state, { field, id }) {
      state.loading[field] = id;
    },
    endLoading(state, field) {
      state.loading[field] = false;
    },
    clearError(state) {
      state.errors = initialState().errors;
    },
    setError(state, {type, errors}) {
      state.errors[type] = errors;
    },

    addProject(state, item) {
      if (!item.id) {
        item.id = state.items.length + 1; // simple id generation
      }
      state.items.push(item)
    },
    delProject(state, id) {
      const ind = state.items.findIndex(el => el.id === id)
      if (ind>=0) {
        state.items.splice(ind, 1);
      }
    },
    editProject(state, project ) {
      const ind = state.items.findIndex(el => el.id === project.id)
      if (ind>=0) {
        state.items.splice(ind, 1, project);
      }
    },
    setItems(state, items) {
      state.items = items
    },
    setCount(state, count) {
      state.count = count;
    },
    setFilterPage(state, page) {
      state.filter.page = parseInt(page, 10);
    },
    setFilterPageSize(state, pageSize) {
      state.filter.pageSize = parseInt(pageSize, 10);
    },
    setFilterName(state, name) {
      state.filter.name = name;
    },
    setFilterRange(state, dates) {
      state.filter.date_from = dates[0];
      state.filter.date_to = dates[1];
    },
    setFilterStatus(state, status) {
      state.filter.status = status;
    },
    setFilterComment(state, comment) {
      state.filter.comment = comment;
    },
    setSelected(state, id) {
      if (id || id === 0) {
        const itemFound = state.selected.some((item) => item === id);
        if (itemFound) {
          state.selected = state.selected.filter((item) => item !== id);
        } else {
          state.selected.push(id);
        }
      } else {
        state.selected = [];
      }
    },
    // allSelected(state) {
    //   state.candidates.forEach((c) => {
    //     if (!state.selected.some((id) => c.id === id)) {
    //       state.selected.push(c.id);
    //     }
    //   });
    // },
    // clearSelected(state) {
    //   state.selected = [];
    // },
    setCurProject(state, item) {
      state.curProject = cloneDeep(item);
    },
    addPosition(state) {
      if (state.curProject)
        state.curProject.positions.push(cloneDeep(emptyPosition))
    },
    removePosition(state, ind) {
      if (state.curProject && state.curProject.positions && state.curProject.positions.length > 0 && 
          ind >= 0 && ind < state.curProject.positions.length) {
          state.curProject.positions.splice(ind, 1);
      } else {
        console.warn('removePosition: no positions to remove');
      }
    },
    setSelectedCandidateId(state, { positionIndex, candidateId }) {
      if (state.curProject && state.curProject.positions && 
          positionIndex >= 0 && positionIndex < state.curProject.positions.length) {
        const position = state.curProject.positions[positionIndex];
        if (position) {
          position.selected_candidate_id = candidateId;
        } else {
          console.warn('setSelectedCandidateId: no position found at index', positionIndex);
        }
      } else {
        console.warn('setSelectedCandidateId: invalid position index', positionIndex);
      }
    }

  },
  actions: {
    async loadItems({ commit, state, getters, rootGetters }) {
      commit('startLoading', 'load');
      
      try {
        // const std = await api.get(`/ai-expert/default-prompts/`)
        const filter = {};
        Object.keys(getters.filter).forEach((key) => {
          if (key === 'page') return;
          if (Array.isArray(getters.filter[key])) {
            if (getters.filter[key].length) {
              filter[key] = getters.filter[key];
            }
            return;
          }
          if (getters.filter[key]) {
            if (key==='type' || key==='source')
              filter[key] = getters.filter[key].split(',') ;
            else
              filter[key] = getters.filter[key];
          }
        });
        
        // const response = await api.post(
        //   `/users/candidates/${candidateId}/dossier/filter/?page=${getters.filter.page}&page_size=${getters.filter.pageSize}`,
        //   filter,
        // );

        await sleep(1000)
        const response = defProjects
        commit('setItems', response);
        commit('setCount', defProjects.length);
      } catch (err) {
        console.log(err);
        commit('setError', { type: 'load', errors: err.data });
      } finally {
        commit('endLoading', 'load');
      }
    },

    async loadProject({ commit, state, getters, rootGetters }, id) {
      commit('startLoading', 'loadProject');
      id = +id
      await sleep(1000)
      try {
        if (id) {
          
          //  const response = await api.get(`/ai-expert/custom-prompts/${id}/`)
          const response = defProjects.find(el => el.id === id)
          console.log(id, response)
          commit('setCurProject', response);
          return response
        } else {
          commit('setCurProject', emptyProject);
          return emptyProject
        }
      } catch (err) {
          console.log(err);
          commit('setError', { type: 'loadProject', errors: err.data });
      } finally {
        commit('endLoading', 'loadProject');
      }
    },

    async delProject({ commit, state, getters, rootGetters }, id) {
        commit('startLoadingId', {field: 'delProject', id } );
        try {
          // const response = await api.delete(`/ai-expert/custom-prompts/${id}/`)
          // console.log(response)
          await sleep(1000)
          commit('delProject', id);
        } catch (err) {
          console.log(err);
          commit('setError', { type: 'delProject', errors: err.data });
        } finally {
          commit('endLoading', 'delProject');
        }
    },

    async saveProject({ commit, state, getters, rootGetters }, project) {
      commit('startLoading', 'saveProject' );
      try {
        if (project.id ) {
          // const response = await api.patch(`/ai-expert/custom-prompts/${prompt.id}/`, prompt)
          await sleep(1000)
          commit('editProject', project );
          return true
        } else {
          // const response = await api.post(`/ai-expert/custom-prompts//`, { content, title: content })
          await sleep(1000)
          commit('addProject', project);
          return true
        }
      } catch (err) {
        console.log(err);
        commit('setError', { type: 'saveProject', errors: err.data });
      } finally {
        commit('endLoading', 'saveProject');
      }
    },

    async findCandidates({ commit, state, getters, rootGetters }, project) {
      commit('startLoading', 'calcProject');
      try {
        if (project && project.positions && project.positions.length > 0) {
          const candidates = [];
          for (const pos of project.positions) {
            const matchedCandidates = matchCandidatesByCompetences(pos.competenses);
            candidates.push({
              ...pos,
              candidates: matchedCandidates,
              selected_candidate_id: matchedCandidates.length? matchedCandidates[0].id : 0, 
            });
          }
          commit('setCurProject', { ...project, positions: candidates });
        }
        await sleep(1000)
        return true;
      } catch (err) {
        console.log(err);
        commit('setError', { type: 'calcProject', errors: err.data });
      } finally {
        commit('endLoading', 'calcProject');    
      } 
    },
    
    async setFilterPage({ commit, dispatch }, page) {
      commit('setFilterPage', page);
      await dispatch('loadItems');
    },
    async setFilterPageSize({ commit, dispatch }, payload) {
      commit('setFilterPage', payload.page);
      commit('setFilterPageSize', payload.pageSize);
      await dispatch('loadItems');
    },
    async setFilterName({ commit, dispatch }, name) {
      commit('setFilterName', name);
      commit('setFilterPage', 1);
      await dispatch('loadItems');
    },
    async setFilterRange({ commit, dispatch }, dates) {
      commit('setFilterRange', dates);
      commit('setFilterPage', 1);
      await dispatch('loadItems');
    },
    async setFilterStatus({ commit, dispatch }, source) {
      commit('setFilterStatus', source);
      commit('setFilterPage', 1);
      await dispatch('loadItems');
    },
    async setFilterComment({ commit, dispatch }, comment) {
      commit('setFilterComment', comment);
      commit('setFilterPage', 1);
      await dispatch('loadItems');
    },
    async setFilterAll({ commit, dispatch }, { params }) {
      commit('setFilterPage', parseInt(params.page, 10) || 1);
      commit('setFilterName', params.name ?? '');
      commit('setFilterStatus', params.source ?? '');
      commit('setFilterComment', params.comment ?? '');
      await dispatch('loadItems');
    },
    async clearFilterAll({ commit, dispatch }) {
      commit('setFilterName', '');
      commit('setFilterStatus', '');
      commit('setFilterComment', '');
      commit('setFilterRange', [null, null]);
      await dispatch('loadItems');
    },

    clearError({ commit }) {
      commit('clearError');
    },
    setSelected({ commit }, id) {
      commit('setSelected', id);
    },
    // allSelected({ commit }) {
    //   commit('allSelected');
    // },
    // clearSelected({ commit }) {
    //   commit('clearSelected');
    // },


  },

};
